import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db09aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]


const __default__ = {
  name: 'AlphaSlider'
}

import { computed, ref } from 'vue'
import { hexToRgb, rgbToRgba, normalizeAlpha } from '@/utils/transformColor'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    hex: null,
    alpha: null,
    onUpdateAlpha: null,
    type: { default: 'default' },
    onComplete: null
  },
  setup(__props: any) {

const props = __props as { hex: string, alpha: number, onUpdateAlpha: (value: number) => void, type: string, onComplete?: () => void }

const HANDLE_SIZE = '12px'
const HANDLE_SIZE_NUM = 12
const RADIUS = '6px'



const railRef = ref<HTMLDivElement | null>(null)

const bgcCheckboard = computed(() => {
  const { hex } = props
  const rgb = hexToRgb(hex.slice(0, 7))
  return `linear-gradient(to right, ${rgbToRgba(rgb, 0)} 0%, ${rgb} 100%)`
})

const handleMouseDown = (e: MouseEvent) => {
  if (!railRef.value || !props.hex) return
  document.body.addEventListener('mousemove', handleMouseMove)
  document.body.addEventListener('mouseup', handleMouseUp)
  handleMouseMove(e)
}

const handleMouseMove = (e: MouseEvent): void => {
  const { value: railEl } = railRef
  if (!railEl) return
  const { width, left } = railEl.getBoundingClientRect()
  const newAlpha = (e.clientX - left) / (width - HANDLE_SIZE_NUM)
  props.onUpdateAlpha(normalizeAlpha(newAlpha))
}

const handleMouseUp = (): void => {
  document.body.removeEventListener('mousemove', handleMouseMove)
  document.body.removeEventListener('mouseup', handleMouseUp)
  props.onComplete?.()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "color-picker-slider",
    ref_key: "railRef",
    ref: railRef,
    onMousedown: handleMouseDown
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['color-picker-checkboard', { common: __props.type === 'common' }])
    }, null, 2),
    _createElementVNode("div", {
      class: "color-picker-slider__image",
      style: _normalizeStyle({ backgroundImage: _unref(bgcCheckboard) })
    }, null, 4),
    _createElementVNode("div", {
      style: _normalizeStyle({
        position: 'absolute',
        left: RADIUS,
        right: RADIUS,
        top: 0,
        bottom: 0
      })
    }, [
      _createElementVNode("div", {
        class: "color-picker-handle",
        style: _normalizeStyle({
          width: HANDLE_SIZE,
          height: HANDLE_SIZE,
          left: `calc(${__props.alpha * 100}% - ${RADIUS})`
        }),
        title: `不透明度${__props.alpha}`
      }, [
        _createElementVNode("div", {
          class: "color-picker-handle__fill",
          style: _normalizeStyle({ backgroundColor: `${_unref(rgbToRgba)(_unref(hexToRgb)(__props.hex), __props.alpha)}` })
        }, null, 4)
      ], 12, _hoisted_1)
    ], 4)
  ], 544))
}
}

})